import type { TreeMapRootNode } from '../types/treemap.js';

/**
 * Clusters single leaf nodes into a cluster node
 * @param tree
 */
export function clusterizeNodes(tree: TreeMapRootNode): TreeMapRootNode {
  const clusterizedNodes = tree.nodes.map((cluster) => {
    const isSingleLeafCluster = !cluster['nodes'];

    if (isSingleLeafCluster) {
      return { ...cluster, nodes: [{ ...cluster }] };
    }
    return cluster;
  });

  return {
    ...tree,
    nodes: clusterizedNodes,
  };
}
